import React from "react";
import { useQuery } from "react-query";
import { tokenGetMe, coinGetMe } from "../services/game.service";
import GameItem from "./items/GameItem";
import { useNavigate } from "react-router-dom";

type Props = {
  tokenBalance?: number;
  coinBalance?: number;
  onBack?: () => void;
};

export default function HeaderBar({
  tokenBalance: propTokenBalance,
  coinBalance: propCoinBalance,
  onBack,
}: Props) {
  const navigate = useNavigate();
  const { data: tokenMe, isLoading: isTokenLoading } = useQuery(
    ["get-token-me"],
    async () => {
      const res = await tokenGetMe({});
      return res;
    }
  );

  const { data: coinMe, isLoading: isCoinLoading } = useQuery(
    ["get-coin-me"],
    async () => {
      const res = await coinGetMe({});
      return res;
    }
  );

  // prefer props when provided (useful for SSR/tests)
  const tokenBalance = propTokenBalance ?? tokenMe?.tokenBalance ?? 0;
  const coinBalance = propCoinBalance ?? coinMe?.coinBalance ?? 0;

  return (
    <div className="pt-4 pl-4 pr-4 pb-0">
      <div className="w-full mb-4 relative">
        <GameItem width={"100%"} itemKey={"header"} />
        <div
          onClick={() => {
            try {
              if (typeof onBack === "function") {
                onBack();
                return;
              } else {
                const data = {
                  action: "close",
                  reason: "user_clicked_button",
                };

                (window as any).ReactNativeWebView.postMessage(
                  JSON.stringify(data)
                );
              }
            } catch (e) {
              console.log("Not in RN WebView");
            }
          }}
          className="absolute top-[4%] left-[2%] bg-transparent w-[15%] aspect-square font-bold text-[24px] cursor-pointer"
        ></div>
      </div>

      {/* token & point */}
      <div className="grid grid-cols-[1fr_1fr_1fr] w-full max-h-[38px] h-[38px] mb-2 relative">
        <div
          style={{
            aspectRatio: "83 / 31",
            overflow: "hidden",
            height: "100%",
            position: "relative",
          }}
          onClick={() => {
            try {
              const data = {
                action: "go_to_token_shop",
                reason: "user_clicked_button",
              };

              (window as any).ReactNativeWebView.postMessage(
                JSON.stringify(data)
              );
            } catch (e) {
              console.log("Not in RN WebView");
            }
          }}
        >
          <img
            src="/images/token_box.png"
            alt="spend-point"
            style={{
              height: "100%",
              width: "auto",
              transform: "translate3d(0,0,0)",
              WebkitTransform: "translate3d(0,0,0)",
              willChange: "transform",
            }}
          />
          <div
            style={{
              position: "absolute",
              left: 37,
              top: 7,
              fontSize: "18px",
              fontWeight: 700,
              color: "#fff",
            }}
          >
            {tokenBalance.toLocaleString()}
          </div>
        </div>

        <div
          style={{
            aspectRatio: "100 / 25",
            overflow: "hidden",
            height: "100%",
            position: "relative",
          }}
        >
          <img
            src="/images/point_box.png"
            alt="spend-point"
            style={{
              height: "100%",
              width: "auto",
              transform: "translate3d(0,0,0)",
              WebkitTransform: "translate3d(0,0,0)",
              willChange: "transform",
            }}
          />
          <div
            style={{
              position: "absolute",
              left: 37,
              top: 7,
              fontSize: "18px",
              fontWeight: 700,
              color: "#fff",
            }}
          >
            {coinBalance.toLocaleString()}
          </div>
        </div>
        <div className="absolute bottom-0 right-[62px]">
          {/* history.png */}
          <div
            className="grid"
            style={{
              width: "50px",
              height: "auto",
              justifyItems: "center",
              alignItems: "center",
            }}
            onClick={() => {
              navigate("/history");
            }}
          >
            <img
              src="/images/history.png"
              alt="spend-point"
              style={{
                width: "100%",
                aspectRatio: "176 / 200",
                transform: "translate3d(0,0,0)",
                WebkitTransform: "translate3d(0,0,0)",
                willChange: "transform",
              }}
            />
          </div>
        </div>

        <div className="absolute bottom-0 right-0">
          <div
            className="grid"
            style={{
              width: "50px",
              height: "auto",
              justifyItems: "center",
              alignItems: "center",
            }}
            onClick={() => {
              try {
                const data = {
                  action: "go_to_shop",
                  reason: "user_clicked_button",
                };

                (window as any).ReactNativeWebView.postMessage(
                  JSON.stringify(data)
                );
              } catch (e) {
                console.log("Not in RN WebView");
              }
            }}
          >
            <img
              src="/images/go2spendPoint.png"
              alt="spend-point"
              style={{
                width: "100%",
                aspectRatio: "176 / 200",
                transform: "translate3d(0,0,0)",
                WebkitTransform: "translate3d(0,0,0)",
                willChange: "transform",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
